// extracted by mini-css-extract-plugin
export var productImage = "_wr-0";